import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import KnowledgeHero from './components/KnowledgeHero';
import KnowledgeCategories from './components/KnowledgeCategories';
import KnowledgeArticles from './components/KnowledgeArticles';
import KnowledgeVideos from './components/KnowledgeVideos';
import KnowledgeCta from './components/KnowledgeCta';
import { useTitle } from '@/hooks/useTitle';
import { SchemaOrg } from '@/components/base/SchemaOrg';

import PageCta from '@/components/feature/PageCta';

const siteUrl = import.meta.env.VITE_SITE_URL;

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  'name': '知識分享｜保險建築師醫療、長照、退休知識',
  'url': `${siteUrl}/knowledge`,
  'description': '保險建築師知識分享專區，提供醫療保險、長期照護、退休規劃、保單健檢等深度文章與影片。',
  'about': {
    '@type': 'Thing',
    'name': '保險知識',
    'description': '涵蓋醫療保險、長期照護、退休規劃、保單健檢等保險知識分享',
  },
};

export default function Knowledge() {
  useTitle({
    title: '知識分享｜保險建築師醫療、長照、退休知識',
    description: '保險建築師知識分享專區，提供醫療保險、長期照護、退休規劃、保單健檢等深度文章與影片。',
    canonicalPath: '/knowledge',
  });
  return (
    <main>
      <SchemaOrg data={schemaData} />
      <Navbar />
      <KnowledgeHero />
      <KnowledgeCategories />
      <KnowledgeArticles />
      <KnowledgeVideos />
      <KnowledgeCta />
      <PageCta />
      <Footer />
    </main>
  );
}